module.exports = __webpack_public_path__ + "img/Fin V1.93d7998e.jpg";